<ng-container *transloco="let t; prefix: 'promoted-icon'">
  @if(promoted) {
    <span>
      <i class="fa fa-angle-double-up ms-1" aria-hidden="true" title="Promoted"></i>
      <span class="visually-hidden">{{t('promoted')}}</span>
    </span>
  }
</ng-container>
